import React from 'react'
import NextLink from 'next/link'

import { Link } from '@wartek-id/link'
import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon'
import { Separator } from '@wartek-id/separator'

import { IS_ASSESSMENT_REVAMP_ENABLED } from 'configs/toggle'

import ImgAssessmentPembelajaran from 'assets/images/assessment/img-assessment-pembelajaran.svg'
import ImgAssessmentAkm from 'assets/images/assessment/img-assessment-akm.svg'

const AssessmentSection = () => {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView?.()
  }
  return (
    <div className="bg-white rounded-b-2xl p-4">
      <div className="mb-6">
        <Text variant="heading-lg" className="!font-semibold">
          Asesmen
        </Text>
        <Text variant="body" className="mb-6">
          Sesuaikan dengan kebutuhan peserta didik Anda. Atau{' '}
          <Link
            className="!font-semibold cursor-pointer"
            onClick={() => scrollTo('faq-section')}
          >
            pelajari asesmen lebih lanjut
          </Link>
        </Text>
      </div>
      {IS_ASSESSMENT_REVAMP_ENABLED && (
        <>
          <div className="mb-6">
            <ImgAssessmentPembelajaran className="mb-4" />
            <Text variant="heading-md" className="!font-semibold">
              Asesmen Pembelajaran
            </Text>
            <Text variant="body" className="mb-4">
              Digunakan guru untuk mengetahui kebutuhan belajar dan mengukur
              capaian perkembangan belajar peserta didik sebagai dasar untuk
              merancang pembelajaran di kelas
            </Text>
            <NextLink href="/assessment/search" passHref>
              <Button color="black" fullWidth>
                Cari Asesmen Pembelajaran
                <Icon className="!text-white ml-2">arrow_right_alt</Icon>
              </Button>
            </NextLink>
          </div>
          <Separator className="mb-6" />
        </>
      )}
      <div className="mb-6">
        <ImgAssessmentAkm className="mb-4" />
        <Text variant="heading-md" className="!font-semibold">
          AKM Kelas
        </Text>
        <Text variant="body" className="mb-4">
          Digunakan sekolah untuk memahami kemampuan literasi dan numerasi
          peserta didik guna merancang strategi pembelajaran di sekolah
        </Text>
        <NextLink href="/assessment/litnum" passHref>
          <Button color="white" fullWidth>
            Cari AKM Kelas
            <Icon className="ml-2">arrow_right_alt</Icon>
          </Button>
        </NextLink>
      </div>
    </div>
  )
}

export default AssessmentSection
